// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createContainer,
	createHook,
	type Action,
} from '@atlassian/react-sweet-state';
import type {
	PropType,
	StoreType,
	ActionType,
	ContainerProps,
	UploadContext,
	Dialog,
	IssueId,
	IssueKey,
} from './types.tsx';

const initialState = {
	openDialog: null,
	issueKey: null,
	issueId: null,
	workType: null,
	mediaUploadContext: null,
} as const;

const actions = {
	setDialogContext:
		(
			openDialog: Dialog | null,
			issueId: IssueId | null,
			issueKey: IssueKey | null,
			mediaUploadContext: UploadContext | null,
			workType?: string | null,
		): Action<StoreType, PropType> =>
		({ setState }) => {
			setState({ openDialog, issueId, issueKey, mediaUploadContext, workType });
		},
} as const;

const Store = createStore<StoreType, ActionType>({
	initialState,
	actions,
	name: 'IssueNavigatorIssueOperationsDialogContext',
});

export const DialogContextContainer = createContainer<StoreType, ActionType, ContainerProps>(Store);

export const useIssueOperationsDialogContext = createHook(Store);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { UploadContext };
